(() => {
  const targets = document.getElementsByClassName('js_select_box');
  const classNameForSelected = 'is-selected';

  window.addEventListener('DOMContentLoaded', () => {
    if (targets.length === 0) {
      return;
    }
    for (const target of targets) {
      target.addEventListener('change', () => {
        if (target.value !== '') {
          target.classList.add(classNameForSelected);
        }
      });
    }
  });
})();